'use client'

import React from 'react'
import { ISection, Language, ITheme } from '@/lib/interfaces/interfaces'
import { NextFont } from 'next/dist/compiled/@next/font'
import DOMPurify from 'dompurify'
import { getInfoBlockContent } from '@/lib/utils/infoBlock'

interface ModernInfoBlockProps {
  section: ISection
  language: Language
  theme: ITheme
  fontStyle: {
    fontFamily: NextFont
    fontSize: string
  }
}

const ModernInfoBlock: React.FC<ModernInfoBlockProps> = ({ section, language, theme, fontStyle }) => {
  const content = getInfoBlockContent(section, language)

  // Sanitizamos el HTML para evitar vulnerabilidades XSS
  const sanitizedContent = typeof window !== 'undefined' ? DOMPurify.sanitize(content) : content

  return (
    <div className='modern-section'>
      <div className='modern-items-grid'>
        <div className='modern-item-wrapper' style={{ '--animation-index': 0 } as React.CSSProperties}>
          <div className='modern-info-block-card'>
            <div
              className='modern-info-block-content'
              style={{
                ...fontStyle.fontFamily.style,
                fontSize: fontStyle.fontSize,
                color: theme.items.nameColor
              }}
              dangerouslySetInnerHTML={{ __html: sanitizedContent }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModernInfoBlock
